import { useCallback, useEffect, useRef, useState } from 'react'

export const useClipboardCopy = ({
  text,
  onCopy,
}: {
  text: string
  onCopy?: (text: string) => void
}) => {
  const [copied, setCopied] = useState(false)
  const previousCopyTextRef = useRef('')

  const copyToClipboard = useCallback(() => {
    const data = [
      new ClipboardItem({
        'text/plain': new Blob([text], { type: 'text/plain' }),
        'text/html': new Blob([`<a href="${text}">${text}</a>`], { type: 'text/html' }),
      }),
    ]

    navigator.clipboard.write(data).then(() => {
      if (text !== previousCopyTextRef.current) {
        onCopy?.(text)
      }
      previousCopyTextRef.current = text
      setCopied(true)
    })
  }, [text, onCopy])

  useEffect(() => {
    if (previousCopyTextRef.current === text) {
      return
    }
    setCopied(false)
  }, [text])

  const resetCopied = useCallback(() => {
    setCopied(false)
  }, [])

  return {
    copied,
    copyToClipboard,
    resetCopied,
  }
}
